// HappieGut homepage: product filter, range shortcuts, hero offset, and the motion system.
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- Product filter + "Explore" range cards ----------
  const filterTo = (cat) => {
    $$('.hg-chip[data-filter]').forEach((b) => {
      const on = b.dataset.filter === cat;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
    $$('.hg-card').forEach((card) => {
      const show = cat === 'all' || card.dataset.cat === cat;
      card.classList.toggle('is-hidden', !show);
      card.classList.remove('is-pop');
      if (show) { void card.offsetWidth; card.classList.add('is-pop'); }
    });
  };
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.hg-chip[data-filter]');
    if (chip) filterTo(chip.dataset.filter);
    const range = e.target.closest('[data-hg-filter]');
    if (range) filterTo(range.dataset.hgFilter);
  });

  // ---------- Hero: where the banner starts (keeps the hover panel on screen) ----------
  const hero = document.getElementById('hg-hero');
  const setTop = () => { if (hero) hero.style.setProperty('--hg-top', Math.round(hero.getBoundingClientRect().top + scrollY) + 'px'); };
  setTop(); addEventListener('resize', setTop); addEventListener('load', setTop);

  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('hg-motion');
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const wide = () => innerWidth > 900;

  // ---------- 1. Mark what should animate ----------
  const mark = (el, cls, delay) => {
    if (!el || el.dataset.hgA) return;
    el.dataset.hgA = '1';
    el.classList.add(...cls.split(' '));
    if (delay) el.style.setProperty('--d', delay + 's');
  };
  // Headings (plain text): split into words
  $$('.hg h2').forEach((h) => {
    if (h.closest('.hg-hero') || h.children.length) return mark(h, 'hg-a');
    const words = h.textContent.trim().split(/\s+/);
    h.innerHTML = words.map((w, i) => `<span class="hg-w"><span style="--wi:${i}">${w}</span></span>`).join(' ');
    h.setAttribute('aria-label', words.join(' '));
    mark(h, 'hg-split');
  });
  $$('.hg-eyebrow').forEach((e) => { if (!e.closest('.hg-hero, .hg-ph')) mark(e, 'hg-a'); });
  // Content pages: .hg-rv fades up, children of .hg-rv-group fade up in a stagger
  $$('.hg-rv').forEach((e, i) => mark(e, 'hg-a', Math.min(i % 4, 3) * 0.05));
  $$('.hg-rv-group').forEach((g) => Array.from(g.children).forEach((c, i) => mark(c, 'hg-a', Math.min(i, 6) * 0.08)));
  $$('.hg-stats-lead, .hg-about-copy p, .hg-why-copy, .hg-science p, .hg-shop-filters, .hg-shop-more, .hg-cta-row, .hg-fact, .hg-compare')
    .forEach((e) => mark(e, 'hg-a', 0.1));
  // Staggered groups
  const stagger = (sel, cls, step = 0.09, max = 6) => $$(sel).forEach((e, i) => mark(e, cls, Math.min(i % max, max) * step));
  stagger('.hg-card', 'hg-a');
  stagger('.hg-stat', 'hg-a hg-a-scale', 0.1);
  stagger('.hg-range', 'hg-a', 0.15);
  // Photos: the wrapper is watched, the photo inside is wiped open
  const clip = (wrap, img, delay) => { if (!wrap || !img) return; img.classList.add('hg-imgclip'); img.style.setProperty('--d', delay + 's'); if (!wrap.dataset.hgA) mark(wrap, 'hg-watch'); };
  $$('.hg-about-media').forEach((f) => clip(f, f.querySelector('picture'), 0.1));
  $$('.hg-range').forEach((r, i) => clip(r, r.querySelector('.hg-range-media'), 0.2 + i * 0.15));
  $$('.hg-compare .hg-compare-row').forEach((row) => $$('.hg-bar', row).forEach((b, i) => b.style.setProperty('--bi', i)));

  // ---------- 2. Reveal on scroll ----------
  const handoff = (el) => {
    // After the entrance, hand the element back to its normal styles (keeps hovers snappy)
    const d = parseFloat(el.style.getPropertyValue('--d')) || 0;
    setTimeout(() => {
      if (el.classList.contains('hg-split') || el.classList.contains('hg-compare')) return;
      el.classList.remove('hg-a', 'hg-a-scale', 'hg-watch', 'is-in');
      $$('.hg-imgclip', el).forEach((c) => c.classList.remove('hg-imgclip', 'is-open'));
    }, (d + 1.9) * 1000);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      el.classList.add('is-in');
      $$('.hg-imgclip', el).forEach((c) => c.classList.add('is-open'));
      io.unobserve(el);
      if (el.classList.contains('hg-stat')) countUp(el.querySelector('.hg-stat-num'), el);
      handoff(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  $$('[data-hg-a]').forEach((el) => {
    // Anything already on screen at load just shows (no flash)
    const r = el.getBoundingClientRect();
    if (r.top < innerHeight * 0.92 && r.bottom > 0) { el.classList.add('is-in'); $$('.hg-imgclip', el).forEach((c) => c.classList.add('is-open')); handoff(el); return; }
    io.observe(el);
  });
  // bars live inside .hg-compare which is marked above
  // ---------- 3. Count-up numbers ----------
  function countUp(el, card) {
    if (!el || el.dataset.done) return;
    el.dataset.done = '1';
    const m = el.textContent.trim().match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
    if (!m) return;
    const [, pre, num, post] = m, target = parseFloat(num), t0 = performance.now(), dur = 1600;
    const d = (parseFloat(card.style.getPropertyValue('--d')) || 0) * 1000;
    const tick = (now) => {
      const k = Math.min(1, Math.max(0, (now - t0 - d) / dur));
      const eased = 1 - Math.pow(1 - k, 4);
      el.textContent = pre + Math.round(target * eased) + post;
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // ---------- 4. Scroll effects: progress line, hero zoom, about parallax ----------
  const bar = document.createElement('div');
  bar.className = 'hg-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  const heroPic = hero && hero.querySelector('.hg-hero-frame');
  const aboutPic = document.querySelector('.hg-about-media picture');
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const max = document.documentElement.scrollHeight - innerHeight;
    bar.style.setProperty('--p', max > 0 ? (scrollY / max).toFixed(4) : 0);
    if (!wide()) return;
    if (heroPic) {
      const h = hero.offsetHeight, k = Math.min(1, Math.max(0, scrollY / h));
      heroPic.style.setProperty('--hz', (1 + k * 0.08).toFixed(4));
      heroPic.style.setProperty('--hd', (k * 0.35).toFixed(3));
    }
    if (aboutPic) {
      const r = aboutPic.parentElement.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        const k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        aboutPic.style.setProperty('--py', (k * -40).toFixed(1) + 'px');
      }
    }
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  // ---------- 5. 3D tilt + glare on product and range cards (mouse only) ----------
  if (fine) {
    $$('.hg-card, .hg-range').forEach((card) => {
      const strength = card.classList.contains('hg-range') ? 5 : 7;
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.classList.add('is-tilt');
        card.style.setProperty('--ry', ((x - 0.5) * strength).toFixed(2) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * strength).toFixed(2) + 'deg');
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', () => {
        card.classList.remove('is-tilt');
        card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
      });
    });
  }
})();
